// @flow

const dispatchAnalyticsOnClick = (link: HTMLElement, product: HTMLElement, win: { document: Document, sessionStorage: Storage, location: Location }) => {
    link.addEventListener("click", function() {
        const { rank } = product.dataset;
        const wrapper = win.document.querySelector(`.product-search-page-body-wrapper`);
        const pageNumber = wrapper ? wrapper.dataset.pageNumber : null;
        const searchTerm = new URLSearchParams(win.location.search).get("query");

        win.sessionStorage.setItem("rank", rank);
        win.sessionStorage.setItem("pageNumber", pageNumber || "");
        win.sessionStorage.setItem("searchTerm", searchTerm || "");
    });
};

export const initViewDetailsAnalytics = (win: { document: Document, sessionStorage: Storage, location: Location }) => {
    try {
        const products = [...win.document.querySelectorAll(`.product-tile`)];

        products.forEach((product: HTMLElement) => {
            const imgLink = product.querySelector(`.product-tile__img-link`);
            const detailNameLink = product.querySelector(`.product-tile__detail-name`);

            if (imgLink) {
                dispatchAnalyticsOnClick(imgLink, product, win);
            }
            if (detailNameLink) {
                dispatchAnalyticsOnClick(detailNameLink, product, win);
            }
        });
    } catch (e) {
        console.error(e);
    }
};
